export const messages = {
  title: { id: 'admin/promotions.form.conditions.shipping-methods.title' },
  subtitle: {
    id: 'admin/promotions.form.conditions.shipping-methods.description',
  },
  input: {
    id: 'admin/promotions.form.conditions.shipping-methods.input',
  },
  edit: { id: 'admin/promotions.utils.edit' },
  create: { id: 'admin/promotions.utils.create' },
  cancel: { id: 'admin/promotions.utils.cancel' },
  discard: { id: 'admin/promotions.utils.discard' },
  save: { id: 'admin/promotions.utils.save' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.shipping-methods.view.title',
    },
  },
  noPermission: {
    id: 'admin/promotions.form.conditions.shipping-methods.unauthorized.description',
  },
}
